import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const VoiceSquare = ({ strokeWidth = 1.5 }): JSX.Element => <g id={'contour'}>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M6 9.85999V14.15' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M9 8.42993V15.5699' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M12 7V17' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M15 8.42993V15.5699' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M18 9.85999V14.15' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path
            d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>

</g>;

export default createSvg(
    VoiceSquare,
    'voice-square',
);
